import { isString } from '../common/utils/stringify';

export interface VersionObject {
  major: number;
  minor: number;
  patch: number;
}

const parseVersion = (version?: string): VersionObject => {
  const obj = { major: NaN, minor: NaN, patch: NaN };
  if (isString(version)) {
    const items = version.split(/\./);
    obj.major = parseInt(items[0]);
    obj.minor = items.length > 1 ? parseInt(items[1]) : NaN;
    obj.patch = items.length > 2 ? parseInt(items[2]) : NaN;
  }
  return obj;
};

export default parseVersion;
